export const translations = {
  en: {
    title: "Sulit PH",
    subtitle: "Senior & PWD Calc",
    mainHeading: "Senior & PWD Discount Calculator",
    description: "Fast, accurate computation for PH shoppers",
    pwdTitle: "Sulit PH",
    pwdSubtitle: "PWD Calc",
    pwdMainHeading: "PWD Discount Calculator",
    pwdDescription: "Fast, accurate PWD computation for PH shoppers",
    individual: "Individual",
    group: "Group",
    pos: "POS / Resto",
    posModeDesc: "Common POS / Restaurant Computation",
    receiptLabel: "Receipt Subtotal (VAT-Inclusive)",
    totalDiners: "Total Diners",
    cardHolders: "Card Holders",
    pwdCardHolders: "Card Holders",
    vatRegistered: "VAT Registered",
    standardPH: "Standard for PH Stores",
    serviceCharge: "10% Service Charge",
    commonResto: "Common in Restaurants",
    amountToPay: "Amount to be Paid",
    totalDiscount: "Total Discount",
    computedVia: "Computed via RA 9994 / RA 10754",
    computedViaPwd: "Computed via RA 10754",
    printBreakdown: "Print Receipt Breakdown",
    resetCalc: "Reset Calculator",
    workOffline: "Work Offline",
    installDesc: "Install on your mobile for instant access anywhere, even without internet.",
    downloadBtn: "DOWNLOAD APP",
    sendToFriend: "SEND TO A FRIEND",
    legalGuide: "Legal Computation Guide",
    langToggle: "PH",
    langLabel: "EN"
  },
  ph: {
    title: "Sulit PH",
    subtitle: "Senior at PWD Calc",
    mainHeading: "Calculator ng Diskwento para sa Senior at PWD",
    description: "Mabilis at tamang kuwenta para sa mamimiling Pinoy",
    pwdTitle: "Sulit PH",
    pwdSubtitle: "PWD Calc",
    pwdMainHeading: "PWD Discount Calculator",
    pwdDescription: "Mabilis at tamang kuwenta ng PWD discount",
    individual: "Isahan",
    group: "Grupo",
    pos: "POS / Resto",
    posModeDesc: "Karaniwang POS / Resto Computation",
    receiptLabel: "Kabuuan ng Resibo (Kasama ang VAT)",
    totalDiners: "Bilang ng Tao",
    cardHolders: "May ID (Senior/PWD)",
    pwdCardHolders: "May ID (PWD)",
    vatRegistered: "Rehistrado sa VAT",
    standardPH: "Karaniwan sa mga tindahan sa PH",
    serviceCharge: "10% Service Charge",
    commonResto: "Karaniwan sa mga Restaurant",
    amountToPay: "Halagang Babayaran",
    totalDiscount: "Kabuuan ng Diskwento",
    computedVia: "Kinuwenta ayon sa RA 9994 / RA 10754",
    computedViaPwd: "Kinuwenta ayon sa RA 10754",
    printBreakdown: "I-print ang Breakdown",
    resetCalc: "Ulitin ang Calculator",
    workOffline: "Gamitin Offline",
    installDesc: "I-install sa iyong mobile para magamit kahit saan, kahit walang internet.",
    downloadBtn: "I-DOWNLOAD ANG APP",
    sendToFriend: "IPADALA SA KAIBIGAN",
    legalGuide: "Gabay sa Pagkuwenta",
    langToggle: "BI",
    langLabel: "PH"
  },
  ceb: {
    title: "Sulit PH",
    subtitle: "Senior ug PWD Calc",
    mainHeading: "Calculator sa Diskwento para sa Senior ug PWD",
    description: "Paspas ug saktong kwenta para sa mga mamalitay sa PH",
    pwdTitle: "Sulit PH",
    pwdSubtitle: "PWD Calc",
    pwdMainHeading: "PWD Discount Calculator",
    pwdDescription: "Paspas ug saktong kwenta sa PWD discount",
    individual: "Kaugalingon",
    group: "Grupo",
    pos: "POS / Resto",
    posModeDesc: "Kasagarang POS / Resto Computation",
    receiptLabel: "Kinatibuk-ang Resibo (Lakip ang VAT)",
    totalDiners: "Gidaghanon sa Tao",
    cardHolders: "Adunay ID (Senior/PWD)",
    pwdCardHolders: "Adunay ID (PWD)",
    vatRegistered: "Rehistrado sa VAT",
    standardPH: "Kasagaran sa mga tindahan sa PH",
    serviceCharge: "10% Service Charge",
    commonResto: "Kasagaran sa mga Restaurant",
    amountToPay: "Kantidad nga Bayranan",
    totalDiscount: "Kinatibuk-ang Diskwento",
    computedVia: "Gikwenta base sa RA 9994 / RA 10754",
    computedViaPwd: "Gikwenta base sa RA 10754",
    printBreakdown: "I-print ang Breakdown",
    resetCalc: "Balika ang Calculator",
    workOffline: "Gamita Offline",
    installDesc: "I-install sa imong mobile para magamit bisan asa, bisan walay internet.",
    downloadBtn: "I-DOWNLOAD ANG APP",
    sendToFriend: "IPADALA SA HIGALA",
    legalGuide: "Giya sa Pagkwenta",
    langToggle: "EN",
    langLabel: "BI"
  }
};